// extracted by mini-css-extract-plugin
export default {"ticket-number":"TicketNumber_ticket-number_gQaMVCLhiSGBsSfY8yUf"};